import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreatePackage($companyId: ID!, $attributes: PackageAttributes!) {
    createPackage(companyId: $companyId, attributes: $attributes) {
       package {
        id
        ...CreatedPackage
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedPackage on Package {
    id
    name
    displayOnWebsite
    rateCents
    availableToEvents
    description
  }
`
